import axiosClient from '@/core/api/axiosClient';
import { ADMINISTRACION_ENDPOINTS } from './endpoints';

/**
 * DTOs para Rol
 */
export interface RolListaDto {
    id: number;
    nombre: string;
    descripcion?: string;
    cantidadUsuarios: number;
}

export interface RolDetalleDto {
    id: number;
    nombre: string;
    descripcion?: string;
    cantidadUsuarios: number;
}

export interface CrearRolDto {
    nombre: string;
    descripcion?: string;
}

export interface ActualizarRolDto {
    nombre: string;
    descripcion?: string;
}

/**
 * DTO para listar roles con paginación
 */
export interface ListarRolesDto {
    roles: RolListaDto[];
    totalRegistros: number;
    paginaActual: number;
    totalPaginas: number;
    tamanoPagina: number;
}

/**
 * Response del backend (ApiResponse con PascalCase)
 */
export interface ApiResponse<T> {
    data?: T;
    message?: string;
    success: boolean;
    errors?: string[];
}

/**
 * Cliente SDK para operaciones de Roles
 * Sigue el mismo patrón que tipoUsuarioClient
 */
export const rolClient = {
    /**
     * Listar todos los roles
     */
    listar: async (): Promise<ApiResponse<ListarRolesDto>> => {
        const response = await axiosClient.get<ApiResponse<ListarRolesDto>>(
            ADMINISTRACION_ENDPOINTS.ROLES.BASE
        );
        return response.data;
    },

    /**
     * Obtener un rol por ID
     */
    obtener: async (id: number): Promise<ApiResponse<RolDetalleDto>> => {
        const response = await axiosClient.get<ApiResponse<RolDetalleDto>>(
            ADMINISTRACION_ENDPOINTS.ROLES.DETAIL(id)
        );
        return response.data;
    },

    /**
     * Crear un nuevo rol
     */
    crear: async (data: CrearRolDto): Promise<ApiResponse<RolDetalleDto>> => {
        const response = await axiosClient.post<ApiResponse<RolDetalleDto>>(
            ADMINISTRACION_ENDPOINTS.ROLES.BASE,
            data
        );
        return response.data;
    },

    /**
     * Actualizar un rol existente
     */
    actualizar: async (id: number, data: ActualizarRolDto): Promise<ApiResponse<RolDetalleDto>> => {
        const response = await axiosClient.put<ApiResponse<RolDetalleDto>>(
            ADMINISTRACION_ENDPOINTS.ROLES.DETAIL(id),
            data
        );
        return response.data;
    },

    /**
     * Eliminar un rol
     */
    eliminar: async (id: number): Promise<ApiResponse<void>> => {
        const response = await axiosClient.delete<ApiResponse<void>>(
            ADMINISTRACION_ENDPOINTS.ROLES.DETAIL(id)
        );
        return response.data;
    }
};
